/**
 * ensureNotificationChannels.ts — Crea los canales Android de cada categoría
 * y registra el tipo de acción rápida "Marcar como leído".
 *
 * QUÉ HACE:
 * - Recorre NOTIFICATION_CHANNEL_RULES y crea (o actualiza) un canal Android
 *   por categoría (Ventas/Inventario/Personal/Sistema), para que el usuario
 *   pueda silenciar una categoría puntual desde Ajustes del sistema.
 * - Registra el tipo de acción `AUDIT_EVENT_ACTION_TYPE_ID` con el botón
 *   "Marcar como leído" que aparece dentro de cada notificación de evento.
 * QUÉ INVOCA: notifications.createChannel / registerActionType de @/lib/platform
 *           (no-op en Web/Escritorio).
 * QUÉ EXPORTA: ensureNotificationChannels, ensureNotificationActionTypes
 * QUÉ NO DEBE HACER: No debe duplicar la lista de categorías (siempre lee de
 *           NOTIFICATION_CHANNEL_RULES, la única fuente de verdad).
 */
import { notifications } from "@/lib/platform";
import {
  NOTIFICATION_CHANNEL_RULES,
  AUDIT_EVENT_ACTION_TYPE_ID,
  MARK_AS_READ_ACTION_ID,
  MARK_AS_READ_ACTION_LABEL,
} from "./mobileNotificationDesign";

export async function ensureNotificationChannels(): Promise<void> {
  const rules = Object.values(NOTIFICATION_CHANNEL_RULES);
  await Promise.all(
    rules.map((rule) =>
      notifications.createChannel({
        id: rule.channelId,
        name: rule.channelName,
        description: rule.channelDescription,
        color: rule.color,
      }),
    ),
  );
}

/** Registra el botón de acción rápida "Marcar como leído" (idempotente). */
export async function ensureNotificationActionTypes(): Promise<void> {
  await notifications.registerActionType(AUDIT_EVENT_ACTION_TYPE_ID, [
    { id: MARK_AS_READ_ACTION_ID, title: MARK_AS_READ_ACTION_LABEL },
  ]);
}
